import { requireAuthentication } from 'Common/auth/AuthenticatedComponent'
import { baseAppInit } from 'Common/base/BaseApp'
import { baseLoader } from 'Common/base/BaseLoader'
import { renderGlobalError } from 'Common/base/renderGlobalError'

export const App = requireAuthentication(baseLoader(baseAppInit(), renderGlobalError))
